import installationInstructions from './installationInstructions';

const petCategoryContent = {
  installationInstructions
}

export { petCategoryContent };
